import React from 'react';
import { motion } from 'framer-motion';
import { Check } from '@phosphor-icons/react';

/**
 * Premium progress stepper (Apple/Uber-inspired).
 * Props:
 *  - steps: string[]  e.g. ["Cart", "Details", "Review", "Success"]
 *  - current: number  (1-indexed)
 */

const getConnectorWidth = (current, idx) => {
  if (current > idx) return '100%';
  if (current === idx) return '50%';
  return '0%';
};

export const ProgressStepper = ({ steps, current }) => {
  return (
    <div className="w-full" data-testid="progress-stepper">
      <div className="flex items-center">
        {steps.map((label, i) => {
          const idx = i + 1;
          const done = current > idx;
          const active = current === idx;
          return (
            <React.Fragment key={label}>
              <div className="flex flex-col items-center flex-shrink-0" style={{ minWidth: 60 }}>
                <motion.div
                  initial={false}
                  animate={{
                    scale: active ? 1.08 : 1,
                    backgroundColor: (done || active) ? '#1A4331' : '#F5F5F4',
                    color: (done || active) ? '#ffffff' : '#78716C',
                  }}
                  transition={{ type: 'spring', stiffness: 260, damping: 22 }}
                  className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold ring-4 ${active ? 'ring-[#1A4331]/15' : 'ring-transparent'}`}
                >
                  {done ? <Check size={16} weight="bold" /> : idx}
                </motion.div>
                <p className={`mt-2 text-[11px] font-semibold uppercase tracking-[0.12em] whitespace-nowrap ${done || active ? 'text-[#1A4331]' : 'text-stone-400'}`}>
                  {label}
                </p>
              </div>
              {i < steps.length - 1 && (
                <div className="flex-1 h-[3px] mx-2 rounded-full bg-stone-200 overflow-hidden">
                  <motion.div
                    initial={{ width: '0%' }}
                    animate={{ width: getConnectorWidth(current, idx) }}
                    transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                    className="h-full bg-[#1A4331]"
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressStepper;
